import React, { memo } from 'react';

import { AvatarCircle } from '@src/components';

import styles from './AvatarDisplay.module.scss';
import useAvatarDisplay from './useAvatarDisplay';

interface AvatarDisplayProps {
  peerId: string;
  peerName: string;
  audioVolumeTmp: number;
}

const AvatarDisplay: React.FC<AvatarDisplayProps> = ({ peerId, audioVolumeTmp }) => {
  const { avatarRef, wavyColor, backgroundColor } = useAvatarDisplay(peerId);

  return (
    <div className={styles.videoBoxAvatarContainer} style={{ backgroundColor }}>
      <div className={styles.backgroundLayer} />
      <div
        className={styles.avatarCircleContainer}
        style={{
          ...(audioVolumeTmp && {
            boxShadow: `0 0 10px ${audioVolumeTmp * 0.8}px ${wavyColor || 'rgba(0, 140, 221, 0.5)'}`,
          }),
        }}
      >
        <AvatarCircle ref={avatarRef} peerId={peerId} className={styles.videoBoxAvatar} />
      </div>
    </div>
  );
};

export default memo(AvatarDisplay);
